export default {
  "root": "_root_i4y5j_1",
  "--side-all": "_--side-all_i4y5j_1",
  "--side-inline": "_--side-inline_i4y5j_1",
  "--side-start": "_--side-start_i4y5j_1",
  "--side-end": "_--side-end_i4y5j_1",
  "--side-block": "_--side-block_i4y5j_1",
  "--side-top": "_--side-top_i4y5j_1",
  "--side-bottom": "_--side-bottom_i4y5j_1"
};import "ni:sha-256;lv-aLW2wBpb20EY2uO5NFTRxSILsOj-_Xnrbwu5UjwU";